import React, { useEffect, useState, useRef, useContext } from 'react'
import { Button } from 'primereact/button'
import { Dialog } from 'primereact/dialog'
import { Toast } from 'primereact'
import { InputText } from 'primereact/inputtext'
import { MultiSelect } from 'primereact/multiselect'
import { Chips } from 'primereact/chips'

import { getRoles } from '../../../API/IT/Roles/RolesRequests'
import { getUsuariosActivos } from '../../../API/IT/Users/UserRequests' 

import Card from '../../../Components/Card/Card'
import Loader from '../../../Components/Loader/Loader'
import { toastShow } from '../../../Services/ToastService'
import { useForm } from '../../../Hooks/useForm'
import { getLabel } from '../../../Services/Language/LanguageService'
import { baseLang } from '../../../Lang/BaseLang'
import { ConfigContext } from '../../../Context/ConfigContext/ConfigContext'
import { EditarListaCorreos, GuardarListaCorreos } from '../../../API/IT/ListaCorreos/ListaCorreosRequest'

const CRUDListaCorreos = ({ show, setShow, getInfoTable, listaEdit }) => {

    const toast = useRef(null)
    const { config } = useContext(ConfigContext);

    const [roles, setRoles] = useState([]);
    const [users, setUsers] = useState([]);
    const [desti, setDesti] = useState('');
    const [CC, setCC] = useState('');
    const [CCo, setCCo] = useState('');
    const [loading, setLoading] = useState(false);
    

    const initialValues ={
        IdListaCorreo: -1,
        Asunto: '',
        Destinatarios: [],
        IdUsersDestinatarios: [],
        IdRolDestinatarios: [],
        CC: [],
        IdUserCC: [],
        IdRolCC: [],
        CCo: [],
        IdUserCCo: [],
        IdRolCCo: []
    }

    const {values, handleInputChange, setValues, error, setError, resetForm } = useForm(initialValues)


    const onHide = () => {
        setShow(false)
        getInfoTable()
    }


    const getInfo = async () => {
        setLoading(true);
        const r = await getRoles();
        const u = await getUsuariosActivos();
        setRoles(r);
        setUsers(u);
        setLoading(false);
    }

    const verificarInfo = () => {
        let error = {};
        if (!values.Asunto) {
          error.Asunto = true;
          error.error = true;
        }
    
        setError(error);
        return error;
    };

    const guardarLista = async () => {
        setLoading(true);
        const e = verificarInfo();
        if (!e.error) {
            const Datos = {
                IdListaCorreo: values.IdListaCorreo,
                Asunto: values.Asunto.length > 0 ? values.Asunto.toString() : null,
    
                Destinatarios: values.Destinatarios.length > 0 ? values.Destinatarios.toString() : null,
                IdUsersDestinatarios: values.IdUsersDestinatarios.length > 0 ? values.IdUsersDestinatarios.map(e => e.IdUser).toString() : null,
                IdRolDestinatarios: values.IdRolDestinatarios.length > 0 ? values.IdRolDestinatarios.map(e => e.IdRol).toString() : null,
    
                CC: values.CC.length > 0 ? values.CC.toString() : null,
                IdUserCC: values.IdUserCC.length > 0 ? values.IdUserCC.map(e => e.IdUser).toString() : null,
                IdRolCC: values.IdRolCC.length > 0 ? values.IdRolCC.map(e => e.IdRol).toString() : null,
    
                CCo: values.CCo.length > 0 ? values.CCo.toString() : null,
                IdUserCCo: values.IdUserCCo.length > 0 ? values.IdUserCCo.map(e => e.IdUser).toString() : null,
                IdRolCCo: values.IdRolCCo.length > 0 ? values.IdRolCCo.map(e => e.IdRol).toString() : null,
    
                DestinatariosMail: desti,
                CCMail: CC,
                CCoMail: CCo
            }
    
            if(Datos.IdListaCorreo > 0){
                const respuesta = await EditarListaCorreos(Datos);
                setLoading(true)
                if(respuesta[0].ESTADO = 1){
                    toastShow(toast, "success", "Editada", respuesta[0].MENSAJE);
                    setTimeout(() => {
                        onHide()
                    }, 1200);
                    setLoading(false)
                }else{
                    toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                }
            }else{
                const respuesta = await GuardarListaCorreos(Datos);
                setLoading(true)
                if(respuesta[0].ESTADO = 1){
                    toastShow(toast, "success", "Guardada", respuesta[0].MENSAJE);
                    setTimeout(() => {
                        onHide()
                    }, 1200);
                    setLoading(false)
                }else{
                    toastShow(toast, "error", "Error", respuesta[0].MENSAJE);
                }
            }
        }
        setLoading(false)
    }

    useEffect(() => {
        getInfo()
    }, [])

    const verificarMail = (mail) => {
        if (mail) {
            if (mail.includes('@')) {
                return mail
            }
        }
        return null;
    }



    useEffect(() => {
        // DESTINATARIOS
        let destinatariosT = []
        let CCT = []
        let CCoT = []


        values.IdUsersDestinatarios.forEach((user) => {
            const t = verificarMail(users.filter(u => u.IdUser === user.IdUser)[0]?.Email);
            if (t) {
                destinatariosT.push(t)
            }
        })

        values.IdRolDestinatarios.map(rol => {
            return users.filter(u => u.IdRol === rol.IdRol).forEach(u => {
                const t = verificarMail(u.Email);
                if (t)
                    destinatariosT.push(t);
            })
        })

        // const destiValue = values.Destinatarios ? values.Destinatarios.join(', ') : '';
        // destinatariosT.push(destiValue);

        if (values.Destinatarios) {
            values.Destinatarios.forEach(dest => {
                const t = verificarMail(dest);
                if (t) destinatariosT.push(t);
            });
        }


        // CC
        values.IdUserCC.forEach((user) => {
            const t = verificarMail(users.filter(u => u.IdUser === user.IdUser)[0]?.Email);
            if (t) {
                CCT.push(t)
            }
        })

        values.IdRolCC.map(rol => {
            return users.filter(u => u.IdRol === rol.IdRol).forEach(u => {
                const t = verificarMail(u.Email)
                if (t) {
                    CCT.push(t);
                }
            })
        })

        // const destiValue1 = values.CC ? values.CC.join(', ') : '';
        // CCT.push(destiValue1);

        if (values.CC) {
            values.CC.forEach(dest => {
                const t = verificarMail(dest);
                if (t) CCT.push(t);
            });
        }



        // CCo
        values.IdUserCCo.forEach((user) => {
            const t = verificarMail(users.filter(u => u.IdUser === user.IdUser)[0]?.Email);
            if (t) {
                CCoT.push(t)
            }
        })

        values.IdRolCCo.forEach(rol => {
            return users.filter(u => u.IdRol === rol.IdRol).forEach(u => {
                const t = verificarMail(u.Email);
                if (t) {
                    CCoT.push(t)
                }
            })
        })

        
        // const destiValue2 = values.CCO ? values.CCO.join(', ') : '';
        // CCT.push(destiValue2);

        if (values.CCo) {
            values.CCo.forEach(dest => {
                const t = verificarMail(dest);
                if (t) CCoT.push(t);
            });
        }


        // console.log(destinatariosT, CCT, CCoT);
        setDesti(destinatariosT.toString());
        setCC(CCT.toString());
        setCCo(CCoT.toString());


    }, [values])

    useEffect(() => {
        if(listaEdit){
            const val = {
                ...listaEdit,
                IdUsersDestinatarios: listaEdit.IdUsersDestinatarios ? users.filter(u => listaEdit.IdUsersDestinatarios.includes(u.IdUser)) : [],
                IdRolDestinatarios: listaEdit.IdRolDestinatarios ? roles.filter(r => listaEdit.IdRolDestinatarios.includes(r.IdRol)) : [],
                IdUserCC: listaEdit.IdUserCC ? users.filter(u => listaEdit.IdUserCC.includes(u.IdUser)) : [],
                IdRolCC: listaEdit.IdRolCC ? roles.filter(r => listaEdit.IdRolCC.includes(r.IdRol)) : [],
                IdUserCCo: listaEdit.IdUserCCo ? users.filter(u => listaEdit.IdUserCCo.includes(u.IdUser)) : [],
                IdRolCCo: listaEdit.IdRolCCo ? roles.filter(r => listaEdit.IdRolCCo.includes(r.IdRol)) : [],
            }
            setValues(val);
        } else {
            setValues({
                IdListaCorreo: -1,
                Asunto: '',
                Destinatarios: [],
                IdUsersDestinatarios: [],
                IdRolDestinatarios: [],
                CC: [],
                IdUserCC: [],
                IdRolCC: [],
                CCo: [],
                IdUserCCo: [],
                IdRolCCo: []
            });
        }
    }, [listaEdit, users, roles]);
    


    return (

        <div>
            <Dialog
                visible={show}
                onHide={onHide}
                style={{ width: '80vw' }}
                header={<div className='mt-3'>
                    <h3>{getLabel(baseLang, "destinatarios", config.language)}</h3>
                    </div>}
                
                footer={<div>
                    <Button label='Cancelar' className="p-button-secondary" onClick={onHide} loading={loading} />
                    <Button label='Guardar' onClick={guardarLista} />
                </div>}
            >
                <div id='editListaCorreo'>
                    <Toast ref={toast} />
                    <Loader loading={loading} querySelector='#editListaCorreo' />
                    <Card
                        titulo={<h4>Asunto</h4>}
                        contenido={<div className='p-4'>
                            <div className="p-float-label">
                                <InputText
                                    style={{ width: '80%' }}
                                    value={values.Asunto}
                                    name='Asunto'
                                    onChange={handleInputChange}
                                    className={error.Asunto ? "p-invalid" : ""}

                                />
                                {/* <label>Asunto</label> */}
                            </div>
                        </div>}
                    />
                    <Card
                        titulo={<h4>Destinatarios</h4>}
                        contenido={
                            <div>
                                                        <div className='p-4 d-flex' style={{ justifyContent: 'space-around' }}>

                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdUsersDestinatarios'
                                    value={values.IdUsersDestinatarios}
                                    onChange={handleInputChange}
                                    options={users}
                                    optionLabel='UserName'
                                    filter
                                />
                                <label>Usuarios</label>
                            </div>
                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdRolDestinatarios'
                                    value={values.IdRolDestinatarios}
                                    onChange={handleInputChange}
                                    options={roles}
                                    optionLabel='Rol'
                                    filter
                                />
                                <label>Rol</label>
                            </div>
                            <div className="p-float-label">
                                {/* <MultiSelect style={{ width: 300 }} /> */}
                                <Chips
                                    name='Destinatarios'
                                    value={values.Destinatarios}
                                    style={{ width: 300 }}
                                    onChange={handleInputChange}
                                />
                                <label>Correos Externos</label>
                            </div>

                        </div>
                                
                            </div>
                        }
                    />

                    <Card
                        titulo={<h4>CC</h4>}
                        contenido={<div className='p-4 d-flex' style={{ justifyContent: 'space-around' }}>

                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdUserCC'
                                    value={values.IdUserCC}
                                    onChange={handleInputChange}
                                    options={users}
                                    optionLabel='UserName'
                                    filter
                                />
                                <label>Usuarios</label>
                            </div>
                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdRolCC'
                                    value={values.IdRolCC}
                                    onChange={handleInputChange}
                                    options={roles}
                                    optionLabel='Rol'
                                    filter
                                />
                                <label>Rol</label>
                            </div>
                            <div className="p-float-label">
                                {/* <MultiSelect style={{ width: 300 }} /> */}
                                <Chips
                                    name='CC'
                                    value={values.CC}
                                    style={{ width: 300 }}
                                    onChange={handleInputChange}
                                />
                                <label>Correos Externos</label>
                            </div>

                        </div>}
                    />

                    <Card
                        titulo={<h4>CCo</h4>}
                        contenido={<div className='p-4 d-flex' style={{ justifyContent: 'space-around' }}>

                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdUserCCo'
                                    value={values.IdUserCCo}
                                    onChange={handleInputChange}
                                    options={users}
                                    optionLabel='UserName'
                                    filter
                                />
                                <label>Usuarios</label>
                            </div>
                            <div className="p-float-label">
                                <MultiSelect
                                    style={{ width: 300 }}
                                    name='IdRolCCo'
                                    value={values.IdRolCCo}
                                    onChange={handleInputChange}
                                    options={roles}
                                    optionLabel='Rol'
                                    filter
                                />
                                <label>Rol</label>
                            </div>
                            <div className="p-float-label">
                                {/* <MultiSelect style={{ width: 300 }} /> */}
                                <Chips
                                    name='CCo'
                                    value={values.CCo}
                                    style={{ width: 300 }}
                                    onChange={handleInputChange}
                                />
                                <label>Correos Externos</label>
                            </div>

                        </div>}
                    />

                    <div>
                        <Card
                            titulo={<h4>Lista de Correos</h4>}
                            contenido={<div className='p-4'>
                                <div>
                                    <h5>Destinatario</h5>
                                    <p>
                                        {desti}
                                    </p>
                                </div>
                                <div>
                                    <h5>CC</h5>
                                    <p>
                                        {CC}
                                    </p>
                                </div>
                                <div>
                                    <h5>CCo</h5>
                                    <p>
                                        {CCo}
                                    </p>
                                </div>

                            </div>}
                        />
                    </div>


                </div>

            </Dialog>
        </div>
    )
}

export default CRUDListaCorreos